import { styled } from 'styled-components'
import { FormContainer as FormContainerBase } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'

export const FormContainer = styled(FormContainerBase)`
  h2 .fi-icon:first-child {
    height: 34px;
    vertical-align: top;
    margin-right: ${({ theme }) => theme.spacing.s};
  }

  & > section:last-child {
    border: 0;
  }
`
